module.exports = __webpack_public_path__ + "static/media/antenista.4beaa7c9.png";